module.exports = __webpack_public_path__ + "img/green-square-table-2.b25ec391.png";